import { useEffect, useState } from "react";

import { useQuery } from "@apollo/client";
import { Alignment, Navbar } from "@blueprintjs/core";
import { Link } from "react-router";

import { Box, Flex } from "@/components/layout/flexbox";
import Logo from "@/components/nav/Logo";
import { LOGO_HEIGHT } from "@/components/pages_logged_in/workspace/nav/SideNav/WorkspaceMenuLogo";
import {
  NAV_Z_INDEX,
  STANDARD_APP_MAX_WIDTH,
  STANDARD_NAV_HEIGHT,
  SUBTEXT_COLOR,
} from "@/css/constants";
import {
  CurrentWorkspaceDocument,
  CurrentWorkspaceQuery,
  CurrentWorkspaceQueryVariables,
} from "@/graphql";

export default function Onboard({
  linkToDash = false,
  showPhone = false,
  backButton = null,
}) {
  const [logoUrl, setLogoUrl] = useState("");
  const navHeight = showPhone ? 100 : STANDARD_NAV_HEIGHT;
  const { data } = useQuery<
    CurrentWorkspaceQuery,
    CurrentWorkspaceQueryVariables
  >(CurrentWorkspaceDocument);

  useEffect(() => {
    if (data?.currentWorkspace?.logo) {
      const { logo } = data.currentWorkspace;
      setLogoUrl(logo.startsWith("/media") ? `${API_HOST}${logo}` : logo);
    }
  }, [data]);

  const logoHeight =
    LOGO_HEIGHT > navHeight - 12 ? navHeight - 12 : LOGO_HEIGHT;

  const logo = logoUrl ? (
    <Box height={logoHeight} m="12px">
      <img
        src={logoUrl}
        style={{
          objectFit: "contain",
          maxWidth: 220,
          width: "100%",
          height: "100%",
        }}
      />
    </Box>
  ) : (
    <Logo height={30} width={150} />
  );

  return (
    <Navbar
      fixedToTop={true}
      style={{ zIndex: NAV_Z_INDEX, height: navHeight }}
    >
      <Box
        style={{
          maxWidth: STANDARD_APP_MAX_WIDTH,
          height: navHeight,
          margin: "0 auto",
        }}
      >
        <Navbar.Group align={Alignment.LEFT} style={{ height: navHeight }}>
          {backButton}
          <Flex>{linkToDash ? <Link to="/dashboard">{logo}</Link> : logo}</Flex>
        </Navbar.Group>
        {showPhone && (
          <Navbar.Group align={Alignment.RIGHT} style={{ height: navHeight }}>
            <Box textAlign="right">
              <Box fontSize={[9, 14]} fontWeight={500}>
                Questions? Talk to an expert
              </Box>
              <Box fontSize={[14, 20]} fontWeight={500}>
                <a href="tel:888-995-0702">1-888-995-0702</a>
              </Box>
              <Box fontSize={[10, 14]} color={SUBTEXT_COLOR}>
                Mon - Fri, 8am - 8pm EST
              </Box>
            </Box>
          </Navbar.Group>
        )}
      </Box>
    </Navbar>
  );
}
